import { createContext } from 'react';
import { jsx } from '@emotion/react';

const PaginationContext = /*#__PURE__*/createContext(null);
function PaginationContextProvider(_ref) {
  let {
    children,
    value
  } = _ref;
  return jsx(PaginationContext.Provider, {
    value: value
  }, children);
}

export { PaginationContext, PaginationContextProvider };
